module.exports = __webpack_public_path__ + "img/3.116ab6f8.jpg";